import { useMemo } from 'react';
import { createSlice } from '@reduxjs/toolkit';
import useClientConfig from '../common/hooks/clientConfigHook';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from '../common/reducers/utilities';

const mapViewSlice = createSlice({
    name: 'mapView',
    initialState: {
        data: { longitude: -0.09, latitude: 51.505, zoom: 13, rotation: 0 }
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => mapViewSlice.getInitialState());
    }
});

// #region network operations
const fetchMapView = network => network.get('/api/v1/mapview', mapViewSlice.actions.set);
export const updateMapView = (network, view) => network.put('/api/v1/mapview', view, mapViewSlice.actions.set);
// #endregion

// #region permission checks
export const canUpdateMapView = (credentials) => credentials.access.hasFull('administrator');
// #endregion

// #region selectors
const selectMapView = state => state.mapView.data;

// #endregion

// #region listeners
const registerMapViewListeners = { }
// #endregion
export const [useDefaultMapView] = dataHookFactory(selectMapView, { run: fetchMapView, listen: registerMapViewListeners });
export const useMapView = () => {
    const clientConfig = useClientConfig();
    const mapView = useDefaultMapView();
    return useMemo(() => ({ ...mapView, ...clientConfig?.mapView }), [mapView, clientConfig?.mapView]);
}

const reducerDetails = { name: mapViewSlice.name, reducer: mapViewSlice.reducer };
export default reducerDetails;